/**
 * widgets/registry.npm.tsx — NPM Proxy Manager widgety (2.1).
 * Hosts / Stream / TTY / Certs / Templates / Edge / Settings.
 */
import { Globe, Layers, Server, Settings, Shield, Wifi } from 'lucide-react';
import type { WidgetSpec } from './types';
import {
  CertsPanel,
  EdgePanel,
  HostsPanel,
  SettingsPanel,
  StreamPanel,
  TemplatesPanel,
  TtyPanel,
} from '../pages/modules/npm/panels';

export const NPM_WIDGETS: WidgetSpec[] = [
  {
    id: 'npm.hosts',
    title: 'HTTP proxy hosts',
    module: 'npm',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.1.0',
    component: HostsPanel,
  },
  {
    id: 'npm.stream',
    title: 'TCP/UDP streams',
    module: 'npm',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Server,
    since: '2.1.0',
    component: StreamPanel,
  },
  {
    id: 'npm.tty',
    title: 'TTY proxy',
    module: 'npm',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Wifi,
    since: '2.1.0',
    component: TtyPanel,
  },
  {
    id: 'npm.certs',
    title: 'Certificates',
    module: 'npm',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Shield,
    since: '2.1.0',
    component: CertsPanel,
  },
  {
    id: 'npm.templates',
    title: 'Templates',
    module: 'npm',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Layers,
    since: '2.1.0',
    component: TemplatesPanel,
  },
  {
    id: 'npm.edge',
    title: 'Edge proxy',
    module: 'npm',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.1.0',
    component: EdgePanel,
  },
  {
    id: 'npm.settings',
    title: 'NPM settings',
    module: 'npm',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Settings,
    since: '2.1.0',
    component: SettingsPanel,
  },
];
